<template>
  <div>
    <div class="xl:block flex items-center">
      <button
        v-if="!isOpen"
        type="button"
        class="w-[32px] h-[32px] md:w-[44px] md:h-[44px] overflow-hidden xl:hidden justify-center"
        @click="$emit('handle-open')"
      >
        <icon-burger-menu />
      </button>
      <button
        v-else
        type="button"
        class="flex items-center justify-center md:p-0 gap-2 uppercase w-[32px] h-[32px] md:w-[44px] md:h-[44px] text-primaryrounded-[5px] overflow-hidden xl:hidden"
        @click="$emit('handle-open')"
      >
        <icon-close />
      </button>
      <router-link
        :to="{ name: '/home' }"
        class="md:mx-auto mr-auto md:ml-auto ml-[12px]"
      >
        <LoginLogo
          :class="{
            'xl:w-[182px] md:w-[92px] w-[75px]': theme === 'kids',
            'top-4 absolute left-4 md:left-6 z-[1]': theme === 'default',
          }"
        />
      </router-link>
    </div>
    <HeaderMobileMenu
      v-show="isOpen"
      class="xl:hidden block z-[100]"
      :is-login-layout="true"
      @close-menu="$emit('handle-open')"
    />
  </div>
</template>

<script setup>
import HeaderMobileMenu from "../header/mobile-menu/HeaderMobileMenu.vue";
import LoginLogo from "./LoginLogo.vue";
import {useCategoriesStore} from "@/stores/categoriesStore";
import {onMounted} from "vue";

const categoriesStore = useCategoriesStore();

defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["handle-open"]);

onMounted(() => {
  categoriesStore.loadCategories();
});
</script>
